export default [
  { nodeType: 'fullName' },
  { nodeType: 'tagline' },
  { nodeType: 'phoneNumber' },
  { nodeType: 'email' },
  { nodeType: 'address' },
  { nodeType: 'workExperience' },
  { nodeType: 'education' },
  { nodeType: 'skills' },
  { nodeType: 'awardsAndHonors' },
  { nodeType: 'certifications' },
  { nodeType: 'projects' },
  { nodeType: 'languages' },
  { nodeType: 'summary' },
  { nodeType: 'volunteerWork' },
  { nodeType: 'patents' },
  { nodeType: 'publications' },
];
